import React from 'react';

import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import styled, { withTheme } from 'styled-components';

import ClarusLogo from 'components/ClarusLogo/ClarusLogo';
import { ERROR_ROUTE } from 'constants/env';
import { FOOTER } from 'constants/message';

const StyledFooterContainer = styled(Box)`
    position: fixed;
    bottom: 0;
    background: ${props => props.theme.palette.white.main};
    color: #313131;
    border-top: 1px solid #e2e2e2;
    height: 40px;
    width: ${props => props.theme.palette.screen.desktop};
    @media (max-width: 767px) {
        width: ${props => props.theme.palette.screen.smallScreen};
    }
`;

const StyledFooterSection = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    height: 40px;
`;

const StyledFooterCol = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

function Footer() {
    const { pathname } = useLocation();
    const is404Page = pathname.startsWith(ERROR_ROUTE);

    return (
        !is404Page && (
            <StyledFooterContainer data-testid="m7sqvznp-bo6bze">
                <StyledFooterSection data-testid="m7sqvznp-icwqmw">
                    <StyledFooterCol data-testid="m7sqvznp-r5qjnq">
                        <Typography
                            variant="span"
                            mr={1}
                            fontSize={16}
                            fontWeight={500}
                        >
                            {FOOTER.LINK_YEAR}
                        </Typography>
                        <ClarusLogo data-testid="m7sqvznp-t6we4n" />
                    </StyledFooterCol>
                </StyledFooterSection>
            </StyledFooterContainer>
        )
    );
}

export default withTheme(Footer);
